import {useSetRecoilState} from 'recoil';
import {useQuery} from 'react-query';
import {healthDeclaration} from '../state/healthDeclaration';
import actions from '../api/healthDeclaration';

const twentyFourHoursInMs = 1000 * 60 * 60 * 24;

const useFetchHealthDeclaration = () => {
  const setHealthDeclaration = useSetRecoilState(healthDeclaration);
  return useQuery('fetchHealthDeclarations', async () => {
    const healthDeclaration = await actions.fetchHealthDeclaration();
    setHealthDeclaration(healthDeclaration?.data);
    return healthDeclaration;
  }, {
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
    staleTime: twentyFourHoursInMs,
  });
};

export default useFetchHealthDeclaration;
